import actions from './manageClient.actions'
import mutations from './manageClient.mutations'

const state = {
  clientDetails: [],
  clientIndex: {},
  clientDatabaseDetails: {},
  clientDatabaseList: []
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
